import { render, staticRenderFns } from "./index_disti.vue?vue&type=template&id=4037562c&scoped=true"
import script from "./index_disti.vue?vue&type=script&lang=js"
export * from "./index_disti.vue?vue&type=script&lang=js"
import style0 from "./index_disti.vue?vue&type=style&index=0&id=4037562c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4037562c",
  null
  
)

export default component.exports